import "../../../styles/main.scss";
import CreatingCamouflageModal from './CreatingCamouflageModal/CreatingCamouflageModal'
import { useEffect, useState } from 'react'
import MergedImages from '../mergeImages/MergedImages'
import useProfileCamouflages from "./Hooks/useUserCamouflages";
import { dialogNotify, displayNotify, displayStandartDialog } from "../../../services/Notifications/NotificationServices";
import useUserDeleteCamouflage from "./Hooks/useUserDeleteCamouflages";
import { CamouflageOwnerType, mixCamouflage } from "./types/camouflageTypes";

//!!!ВАЖНО идея типизации компонента заключается в том, чтобы сделать его более универсальным. 
// Можно написать отдельные хуки для получения данных для камуфляжей команды и сделать логику их использования здесь 
// в зависимости от указанного типа 

//еще не менее важный момент: когда много камуфляжей, нижние элементы модалки едут вниз, надо это пофиксить
export default function MultiSelectCamouflage({ type, slug = null }: { type: CamouflageOwnerType, slug?: string | undefined | null }) {
    const [isOpenModal, setIsOpenModal] = useState(false)

    const { data, isLoading, error } = useProfileCamouflages(type, slug)
    // ↓ Стейт камуфляжей. Позволяет моментально изменять визуальное состояние и фоново отправлять запросы. 
    const [localCamouflages, setLocalCamouflages] = useState(data || []);
    const { mutate: deleteMutate } = useUserDeleteCamouflage(type, slug)

    useEffect(() => {
        if (data) {
            setLocalCamouflages(data);
        }
    }, [data]);


    // ↓ Обработчик удаления камуфляжа
    const handleDelete = (mixId: string) => {

        dialogNotify({
            status: 'info', title: 'Удаление камуфляжа', description: 'Вы уверены, что хотите удалить камуфляж ?', acceptText: 'Да', acceptHandler: () => {
                setLocalCamouflages((prev: any[]) =>
                    prev.filter((camo) => camo.mix_id !== mixId)
                );

                deleteMutate(mixId, {
                    onError: () => {
                        // Если ошибка — возвращаем элемент обратно
                        setLocalCamouflages(data || []);
                    },
                });
            }
        })
    };


    return (
        <div className='multiSelectCamouflage'>
            <div className='multiSelectCamouflage-camouflageList'>
                <h3>Камуфляж</h3>
                {data?.length === 0 ? (
                    <p>Нажмите на "+", чтобы создать и добавить новый камуфляж</p>
                ) : (
                    <div className='multiSelectCamouflage-camouflageList-items'>
                        {localCamouflages.map((camo: mixCamouflage, index: number) => (
                            <div key={index} className='multiSelectCamouflage-camouflageList-items-item'>
                                <MergedImages srcs={camo.camouflages.map(item => item.img)} radius={23} className='multiSelectCamouflage-camouflageList-items-item-img' />
                                <p>{camo?.camouflages.length === 1 ? camo.camouflages[0].name : 'Комбинированный'}</p>
                                <button
                                    type='button'
                                    onClick={() => handleDelete(camo.mix_id)}
                                >
                                    <img src='/UI/closeIconBlack.svg' />
                                </button>
                            </div>
                        ))}
                    </div>
                )}
            </div>
            <button
                type='button'
                className='multiSelectCamouflage-addButton'
                onClick={() => {
                    if (data?.length === 10) {
                        displayNotify({
                            status: 'error',
                            title: 'Нельзя создать камуфляж',
                            description: `${type === 'profile' ? 'Пользователь' : 'Команда'} может иметь не более 10 миксов камуфляжей`
                        })
                    }
                    else {
                        setIsOpenModal(true)
                    }
                }}
            >
                <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clipRule="evenodd" d="M0.651367 8.99998C0.651368 8.58526 0.987568 8.24906 1.40229 8.24906L8.0747 8.24906L8.07468 1.57667C8.07468 1.16195 8.41088 0.825747 8.8256 0.825745C9.24033 0.825743 9.57653 1.16194 9.57653 1.57667L9.57655 8.24906L16.2489 8.24906C16.6636 8.24906 16.9998 8.58526 16.9998 8.99998C16.9998 9.41471 16.6636 9.75091 16.2489 9.75091L9.57655 9.75091L9.57653 16.4233C9.57653 16.838 9.24033 17.1742 8.8256 17.1742C8.41088 17.1742 8.07468 16.838 8.07468 16.4233L8.0747 9.75091L1.40229 9.75091C0.987566 9.75091 0.651367 9.41471 0.651367 8.99998Z" fill="#62666D" />
                </svg>
            </button>
            <CreatingCamouflageModal isOpen={isOpenModal} setIsOpen={setIsOpenModal} type={type} slug={slug} />
        </div>
    )
}